class PPMediaVideo extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.button = this.querySelector('.pp-media__play');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!this.video || !this.button) return;

    this.button.addEventListener('click', this.togglePlayback);
    this.video.addEventListener('play', this.syncPlaybackState);
    this.video.addEventListener('pause', this.syncPlaybackState);
    this.video.addEventListener('ended', this.syncPlaybackState);
    this.reducedMotion.addEventListener('change', this.handleMotionPreference);

    this.syncPlaybackState();

    if (this.dataset.autoplayLoop === 'true' && !this.reducedMotion.matches) {
      this.video.muted = true;
      this.video.play().catch(() => this.syncPlaybackState());
    }
  }

  disconnectedCallback() {
    if (!this.video || !this.button) return;

    this.button.removeEventListener('click', this.togglePlayback);
    this.video.removeEventListener('play', this.syncPlaybackState);
    this.video.removeEventListener('pause', this.syncPlaybackState);
    this.video.removeEventListener('ended', this.syncPlaybackState);
    this.reducedMotion?.removeEventListener('change', this.handleMotionPreference);
  }

  togglePlayback = () => {
    if (this.video.paused) {
      this.video.play().catch(() => this.syncPlaybackState());
    } else {
      this.video.pause();
    }
  };

  syncPlaybackState = () => {
    const isPlaying = !this.video.paused && !this.video.ended;
    this.dataset.playing = String(isPlaying);
    this.button.setAttribute('aria-pressed', String(isPlaying));
    this.button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
  };

  handleMotionPreference = (event) => {
    if (!event.matches || this.video.paused) return;

    this.video.pause();
    this.video.currentTime = 0;
  };
}

if (!customElements.get('pp-media-video')) {
  customElements.define('pp-media-video', PPMediaVideo);
}
